<template>
  <div class="setting">
    <div class="setting-wrap">
      <!-- <div class="versions">
        <div>当前版本</div>
        <p>V.1.1.1</p>
      </div> -->
      <div class="setting-list">
        <van-cell is-link @click="$router.push('/mine/changephone')">
          <template #title>
            <img src="../../assets/images/mine/setting-phone-ico.png" alt="" />
            <span>换绑手机</span>
          </template>
        </van-cell>
        <van-cell is-link @click="$router.push('/pwdretrieve')">
          <template #title>
            <img src="../../assets/images/mine/setting-pwd-ico.png" alt="" />
            <span>修改密码</span>
          </template>
        </van-cell>
        <van-cell is-link @click="getout">
          <template #title>
            <img class="out" src="../../assets/images/mine/out.png" alt="" />
            <span>注销账号</span>
          </template>
        </van-cell>
      </div>
      <div class="logout">
        <van-button size="large" color="#FA665A" @click="logout"
          >退出登录</van-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import { userCancel } from "@/utils/api/user";
export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions(["setUserInfo"]),
    getout(){
      userCancel().then((res) => {
        console.log('注销',res);
        if (res.success) {
          this.logout();
        }else{
          this.$toast.fail(res.data);
        }
      });
    },
    logout() {
      this.setUserInfo({});
      this.$router.push("/login");
      // window.sessionStorage.clear();
      // window.localStorage.clear();
      // window.location.reload();
    }
  }
};
</script>

<style lang="scss" scoped>
.setting {
  background: #fff;
  height: 100%;
  .setting-wrap {
    background: #fff;
    padding: 0 20px;
    .versions {
      height: 100px;

      overflow: hidden;
      div {
        margin-top: 32px;
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        color: #666;
        margin-top: 30px;
      }
      p {
        margin-top: 10px;
        font-size: 14px;
        color: #999;
      }
    }
    .setting-list {
      margin-top: 20px;
    }
    .logout {
      margin: 0 auto;
      margin-top: 220px;
      width: 290px;
      height: 46px;
    }
  }
}
</style>
<style lang="scss">
.setting {
  .van-cell {
    &::after {
      border: none;
    }
  }
  .van-cell__title {
    text-align: left;
    display: flex;
    align-items: center;
    font-size: 16px;
    img {
      margin-right: 12px;
    }
    .out{
      width: 15px;
      height: 19px;
      margin-right: 9.8px;
    }
  }
  .setting-list {
    position: relative;
    // &::after {
    //   position: absolute;
    //   box-sizing: border-box;
    //   content: " ";
    //   pointer-events: none;
    //   right: 16px;
    //   bottom: 0;
    //   left: 16px;
    //   border-bottom: 1px solid #ebedf0;
    //   -webkit-transform: scaleY(0.5);
    //   transform: scaleY(0.5);
    // }
  }
  .logout {
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
      font-size: 14px;
    }
  }
}
</style>
